import $axios from "../../api";

// MODULE NAME
const PREFIX = "website/mailchimp";

const state = () => ({
  isLoading: false,
  isLoadingSync: false,
  errors: "",
  isSuccess: false,
  campaignList: [],
  page: 1,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_SYNC(state, payload) {
    state.isLoadingSync = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_CAMPAIGN_LIST(state, payload) {
    state.campaignList = payload;
  },
};

const actions = {
  createCampaign({ commit, state, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_LOADING_SYNC", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/campaign/create`, payload)
        .then((response) => {
          commit("SET_SUCCESS", true);
          commit("SET_LOADING_SYNC", false);
        })
        .catch((error) => {
          commit("SET_ERRORS", error.response.data.errors);
          commit("SET_SUCCESS", false);
          commit("SET_LOADING_SYNC", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true })
        });
    });
  },
  getCampaign({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/campaign/list?page=${state.page}&view=${rootState.Main.view}${payload ? payload : ""}`)
        .then((res) => {
          commit("SET_CAMPAIGN_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};